import LogRocket from 'logrocket'
import { watch } from 'vue'
import { config } from '../main'
import { state } from '../state'

export function initialize() {
  if (navigator.webdriver || import.meta.env.DEV) {
    return
  }

  LogRocket.init(config.logRocketAppId, {
    network: {
      requestSanitizer: request => {
        if (request.url.includes('login')) {
          request.body = 'REDACTED'
        }
        // don't track app insights requests
        if (request.url == 'https://dc.services.visualstudio.com/v2/track') {
          return null
        }
        return request
      }
    }
  })

  watch(
    () => state.user,
    user => {
      if (user) {
        LogRocket.identify(user.id, {
          email: user.email,
          organizationId: state.organizationId ?? '',
          isHeadset: state.vuplex != null
        })
      }
    }
  )
}

export function trackEvent(eventName: string, properties?: { revenue?: number; [name: string]: unknown }) {
  if (navigator.webdriver || import.meta.env.DEV) {
    return
  }
  LogRocket.track(eventName, {
    ...properties,
    userId: state.user?.id,
    deviceId: state.vuplex?.deviceId,
    organizationId: state.organizationId
  })
}
